import * as React from 'react'
import { FC } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../store/hook'

import Element from '../../../../domain/Element/Element'
import FormGateway from '../../../../gateway/Form/FormGateway'
import SaveUseCase from '../../../../domain/Form/SaveUseCase'
import { updateElementTimestamp } from '../../../../store/element/elements'
import getElementsIdToRender from '../../../util/getElementsIdToRender'
import { computeSharesFromAmount, parseAmount } from '../../../../domain/Product/ComputeSharesFromAmount'

import Input from '../input/Input'

interface IProps {
    element: Element
    register: any
    clearErrors: (id: string | undefined) => void
}

const OutputSharesFromAmount: FC<IProps> = ({ element, register, clearErrors }) => {
    const dispatch = useAppDispatch()

    const elementsWithReferenceJSON = useAppSelector(state => state.elements.currentElementsWithReference)
    const elementsWithReference: Element[] = JSON.parse(elementsWithReferenceJSON)

    const elementsWithCalculeJSON = useAppSelector(state => state.elements.currentElementsWithCalcule)
    const elementsWithCalcule: Element[] = JSON.parse(elementsWithCalculeJSON)

    const attributes = element.attributes
    const decimalise = attributes?.decimalise ?? false
    const nbDecimale = attributes?.nbDecimale ?? 0
    const unitPrice = attributes?.unitPrice ?? null
    const amountElement = attributes?.amountElement

    const formGateway = new FormGateway()
    const formValues = formGateway.getCurrentValueForFormId().values as Record<string, unknown>

    const rawAmount = amountElement ? formValues[amountElement] : undefined
    const amount = parseAmount(rawAmount) ?? 0
    const value = computeSharesFromAmount(amount, unitPrice, decimalise, nbDecimale)

    if (formValues[element.id] === undefined || String(value) !== String(formValues[element.id])) {
        const data: Record<string, unknown> = {}
        data[element.id] = value
        const saveUseCase = new SaveUseCase(formGateway)
        saveUseCase.execute(data as never).then(() => {
            const elementsIdToRender: string[] = getElementsIdToRender(
                null,
                element.id,
                elementsWithCalcule,
                elementsWithReference,
            )
            elementsIdToRender.forEach(id => dispatch(updateElementTimestamp({ id })))
        })
    }

    return <Input
        classes={element.cssClasses}
        label={attributes?.label}
        register={register}
        clearErrors={clearErrors}
        type={'text'}
        readOnly={true}
        id={element.id}
        name={element.name}
        placeholder={attributes?.label}
        help={attributes?.help}
        value={String(value)}
    />
}

export default OutputSharesFromAmount
